<template>
  <div class="new-sds-container" v-loading="loading">
    <div class="tabs-wrapper">
      <el-tabs type="border-card" v-model="tabModel" @tab-click="handleTabClick">
        <el-tab-pane
          :lazy="true"
          v-for="(item, index) in sortedAuditedList"
          :key="item.id + '_' + item.revNumber"
          :name="'audited_tab' + (index + 1)"
        >
          <span slot="label"
            ><i class="el-icon-date"></i> Version {{ item.revNumber }} <i class="el-icon-edit" @click="editVersion(item)"></i>
          </span>
          <ZDComponentsVue
            :modules="getAuditedData(item)"
            :tabId="'audited_tab' + (index + 1)"
            :pageStatus="pageStatus"
          ></ZDComponentsVue>
        </el-tab-pane>
        <el-tab-pane
          v-loading="loading"
          element-loading-text="data loading"
          name="tab1"
          class="tab"
        >
          <span slot="label"><i class="el-icon-date"></i> Detail Manager</span>
          <ZDComponentsVue
            v-if="isComponentsLoad"
            :modules="detailData"
            :tabId="'tab1'"
            :key="detailDataKey"
            :shelflifeNumber="shelflifeNumber"
            :pageStatus="pageStatus"
            @update:shelflifeNumber="updateShelflifeNumber"
          ></ZDComponentsVue>
        </el-tab-pane>
      </el-tabs>
      <el-button 
        class="logout-btn" 
        type="danger" 
        size="small" 
        icon="el-icon-switch-button"
        @click="handleLogout"
      >
        {{ $t('view.login_out') }}
      </el-button>
    </div>
    <ZDRevPopover
      v-if="pageStatus != 'Add'"
      :pageStatus="pageStatus"
      :versionInfo="versionInfo"
      :language="currentData.language.toUpperCase()"
    ></ZDRevPopover>
  </div>
</template>

<script>
import ZDComponentsVue from "./ZDComponents.vue";
import ZDRevPopover from "./zd-modules/ZDRevPopover.vue";
import { apiServer } from "@/network/modules/detail-api";
import * as TemplateData from "@/views/NEW/module/template/index.js";
import { EventBus } from "../spec/config/eventBus";
import zhCoaResultDefaultValue from "./utils/zh_coa_result_default_value.json";
export default {
  components: {
    ZDComponentsVue,
    ZDRevPopover,
  },
  computed: {
    isComponentsLoad() {
      return this.detailData && Object.keys(this.detailData).length;
    },
    // 新增：获取正确排序的审核版本列表
    sortedAuditedList() {
      if (!this.auditedList || this.auditedList.length === 0) {
        return [];
      }

      // 按照revNumber降序排列，确保最新版本在前
      return [...this.auditedList].sort((a, b) => {
        const revA = parseInt(a.revNumber) || 0;
        const revB = parseInt(b.revNumber) || 0;
        return revB - revA; // 降序排列
      });
    },
  },
  data() {
    return {
      loading: false, // 加载中
      auditedList: [], // 版本信息
      tabModel: "tab1",
      pageStatus: "Add", // 页面状态：Add、Detail、Edit
      productType: "CSFMU-B", //默认的产品类型，spec 为 CSFMU-B、COA 为 CSFMU-A
      itemCode: "",
      detailData: {}, //详情数据
      defaultLoadData: {},
      notesData: {}, //备注信息
      // 添加统一的notes和配置管理
      notesConfig: {
        customNotes: [], // 自定义notes数组
        additionalNotes: {
          // 额外的notes配置
          note1: false,
          note2: false,
          note3: false,
          is_show_note: true,
        },
        specNoteArr: []
      },
      oldtCustomFieldData: {
        analysis: [],
        microbiological_tests: [],
        fatty_acid: [],
      },
      // 添加当前数据管理
      currentData: {
        itemCode: "",
        productType: "CSFMU-B",
        language: "EN",
        verified: false,
        verifiedTime: null,
        createTime: null,
        updateTime: null,
        pageStatus: "Add", // 添加页面状态管理
        // 添加这些字段的默认值
        qty: 0,
        shipmentDate: "",
        shippingMethod: "",
        tyNumber: "",
        chinaLot: "",
        manufacutureDate: "", // 添加制造日期字段
        shelflifeNumber: 24, // 从PanelDetail的data中获取
        notes: [],
      },
      detailDataKey: 0,
      isLoading: false, // 添加加载状态标志，防止重复调用
      versionInfo: {
        revNumber: "",
        createName: "",
        createTime: "",
        updateName: "",
        updateTime: "",
        verifiedName: "",
        verifiedTime: "",
      },
      // 添加当前Custom Field数据的存储
      currentCustomFieldData: {
        analysis: [],
        microbiological_tests: [],
        fatty_acid: [],
      },
      shelflifeNumber: 24, // 添加 shelflifeNumber 默认值
    };
  },
  provide() {
    return {
      productTypeChange: this.productTypeChange,
      getNotesDataMethod: this.getNotesData,
      setNotesDataMethod: this.setCoaNotes,
      // 添加新的方法
      getNotesConfigMethod: this.getNotesConfig,
      setNotesConfigMethod: this.setNotesConfig,
      getCustomNotesMethod: this.getCustomNotes,
      setCustomNotesMethod: this.setCustomNotes,
      addCustomNoteMethod: this.addCustomNote,
      removeCustomNoteMethod: this.removeCustomNote,
      setAdditionalNotesConfigMethod: this.setAdditionalNotesConfig,
      getCurrentDataMethod: this.getCurrentData,
      importSpecDataMethod: this.loadSpecDataByItemCode,
      setItemCodeDataMethod: this.setItemCode,
      setupProductDescription: this.setupProductDescription,
      getVersionInfoMethod: this.getVersionInfo,
      getShelflifeNumberMethod: this.getShelflifeNumber, // 提供获取 shelflifeNumber 的方法
    };
  },
  created() {
    let id = this.$route.query.id;
    console.info("id:", id);
    // let type = this.$route.query.type;
    let isCopy = this.$route.query.isCopy;
    let language = this.$route.query.language.toLocaleLowerCase();

    // 设置当前数据
    this.currentData.language = ["zh", "cn"].includes(language)
      ? "cn"
      : language;

    if (!id) {
      this.pageStatus = "Add";
      this.currentData.pageStatus = "Add";
      this.loadTemplateData();
      this.tabModel = "tab1"; // 新增状态下默认显示 Detail Manager 标签页
    } else if (isCopy === "true") {
      // isCopy 的值可能是字符串
      this.pageStatus = "Add"; // 复制操作意味着创建新项，初始状态为 Add
      this.currentData.pageStatus = "Add";
      this.loadData(); // 加载要复制的数据
      this.loadAuditVersionData(); // 同时加载版本信息，但新项不会有版本
      this.tabModel = "tab1"; // 复制后默认显示 Detail Manager 标签页
    } else {
      // 对于现有页面，先加载数据和版本
      this.pageStatus = "Edit";
      this.currentData.pageStatus = "Edit";
      this.loadData();
      this.loadAuditVersionData();
      // pageStatus 和 tabModel 将在 loadAuditVersionData 的回调中设置
    }

    // 初始化制造日期（如果localStorage中存在）
    const manufacutureDate = localStorage.getItem("ManufacutureDate");
    if (manufacutureDate) {
      this.currentData.manufacutureDate = manufacutureDate;
    }
  },
  methods: {
    editVersion(item) {
      this.$prompt(
        this.$t('confirm.please_input_new_version_number'),
        this.$t('confirm.tips'), {
          confirmButtonText: this.$t("confirm.ok"),
          cancelButtonText: this.$t("confirm.cancel"),
          inputValue: item.revNumber,
          inputPlaceholder: this.$t("confirm.please_input_new_version_number"),
          closeOnClickModal: false,
          inputPattern: /^.+$/, // 简单校验非空
          inputErrorMessage: this.$t("confirm.version_number_cannot_be_empty")
        }
      ).then(({ value }) => {
        this.$loading({ lock: true, text: this.$t('action.version_update') + '...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.3)' });
        let params = {
          id: item.id,
          auditedId: item.auditedId,
          rev: value,
        };
        apiServer.getDataByType("spec", "updateVersion", params, () => {
          this.$message({ type: "success", message: this.$t("Save Successfully") });
          // 刷新数据以获取最新状态
          this.$loading().close();
          this.$router.go(0);
        });
      }).catch(() => {
        // 点击取消，不做任何处理，弹框自动关闭
      });
    },
    updateShelflifeNumber(newVal) {
      this.shelflifeNumber = newVal;
    },
    // 新增：获取当前数据
    getCurrentData() {
      return this.currentData;
    },

    // 新增：获取版本信息
    getVersionInfo() {
      // 修复：确保返回的是当前最新的版本信息
      console.info(
        "getVersionInfo called, current versionInfo:",
        this.versionInfo
      );
      console.info("Current sortedAuditedList:", this.sortedAuditedList);
      return this.versionInfo;
    },

    // 新增：获取notes配置
    getNotesConfig() {
      return this.notesConfig;
    },

    // 新增：设置notes配置
    setNotesConfig(config) {
      // console.info("setNotesConfig:",config)
      this.notesConfig = { ...this.notesConfig, ...config };
      console.info("notesConfig111:",this.notesConfig)
    },

    // 新增：获取自定义notes
    getCustomNotes() {
      return this.notesConfig.customNotes;
    },

    // 新增：设置自定义notes
    setCustomNotes(notes) {
      this.notesConfig.customNotes = Array.isArray(notes) ? notes : [];
    },

    // 新增：添加单个note
    addCustomNote(note) {
      if (note && note.trim()) {
        this.notesConfig.customNotes.push(note.trim());
      }
    },

    // 新增：删除单个note
    removeCustomNote(index) {
      if (index >= 0 && index < this.notesConfig.customNotes.length) {
        this.notesConfig.customNotes.splice(index, 1);
      }
    },

    // 修复：更新 custom_field 组件状态的辅助方法
    updateCustomFieldComponentState(moduleName, fieldKey) {
      try {
        // 获取字段信息
        const field = this.detailData[moduleName][fieldKey];
        if (!field) {
          console.warn(`Field ${fieldKey} not found in ${moduleName}`);
          return;
        }

        // 构造组件ID（与 ZDComponents.vue 中的 getZdId 逻辑保持一致）
        const fieldLabel = field.label ? field.label.toLowerCase().replaceAll(" ", "_") : fieldKey;
        const fieldIndex = Object.keys(this.detailData[moduleName]).indexOf(fieldKey);
        const componentId = `tab1_${fieldLabel}_id_${field.type}_${fieldIndex}`;

        // 更新 Vuex store 中对应组件的状态
        this.$store.dispatch('zdInput/updateComponent', {
          id: componentId,
          field: 'value',
          value: field.value
        });

        // console.info(`Updated component ${componentId} with value:`, field.value);
      } catch (error) {
        console.error('Error updating custom field component state:', error);
      }
    },

    // 新增：设置额外notes配置
    setAdditionalNotesConfig(config) {
      this.notesConfig.additionalNotes = {
        ...this.notesConfig.additionalNotes,
        ...config,
      };
    },

    loadCoaDataBySpecItemCode(itemCode) {
      apiServer.getDataByType(
        "spec",
        "getDetailByItemCode",
        { itemCode },
        (data) => {
          this.versionInfo.revNumber = data.revNumber;
          this.versionInfo.createTime = data.createTime
            ? data.createTime.substring(0, 10)
            : "";
          this.versionInfo.updateTime = data.updateTime
            ? data.updateTime.substring(0, 10)
            : "";
        }
      );
    },
    setItemCode(itemCode, callback) {
      this.itemCode = itemCode;
      this.currentData.itemCode = itemCode; // 同步到currentData
      let type = this.$route.query.type;
      if (
        (this.pageStatus == "Add" && type == "spec") ||
        (type == "coa" && itemCode)
      ) {
        // 判断 itemCode 是否已经存在
        apiServer.getDataByType(
          "spec",
          "itemCodeExist",
          { itemCode },
          (data) => {
            if (data) {
              this.$message({
                showClose: true,
                message: this.$t("confirm.item_code_already_exists"),
                type: "error",
              });
            }
            if (callback) {
              callback(data);
            }
          }
        );
      }
    },
    getNotesData() {
      // 修复：优先从notesConfig获取数据
      if (this.notesConfig.customNotes.length > 0) {
        return this.notesConfig.customNotes;
      }

      // 修复：检查是否存在originalValue，如果存在则返回原始数组数据
      if (this.detailData.other_notes && this.detailData.other_notes.notes) {
        const notesField = this.detailData.other_notes.notes;
        if (notesField.originalValue) {
          return notesField.originalValue;
        }
        // 如果没有originalValue，检查value的类型
        if (Array.isArray(notesField.value)) {
          return notesField.value;
        }
        // 如果value是字符串且包含@$分隔符，则转换为数组
        if (
          typeof notesField.value === "string" &&
          notesField.value.includes("@$")
        ) {
          return notesField.value.split("@$").filter(function (item) {
            return item.trim().length > 0;
          });
        }
        // 如果value是非空字符串，转换为单项数组
        if (
          typeof notesField.value === "string" &&
          notesField.value.trim().length > 0
        ) {
          return [notesField.value];
        }
      }
      return [];
    },
    setCoaNotes(notes) {
      this.notesData = Object.assign({}, notes);
      // 同步到notesConfig
      if (notes.additionalNotes) {
        this.notesConfig.additionalNotes = {
          ...this.notesConfig.additionalNotes,
          ...notes.additionalNotes,
        };
      }
    },
    // tab切换
    handleTabClick(tab) {
      // console.info("Tab clicked:", tab.name);

      // 修复：正确区分Version Tab和Detail Manager
      if (tab.name === "tab1") {
        this.pageStatus = "Edit"; // 修复：Detail Manager 页面应该是编辑状态
        this.currentData.pageStatus = "Edit"; // 修复：Detail Manager 页面应该是编辑状态

        // 修复：切换到Detail Manager时，恢复原始版本信息
        this.updateVersionInfoFromDetailData();
      } else if (tab.name.startsWith("audited_tab")) {
        // Version Tab 页 - 设置为详情不可编辑状态
        this.pageStatus = "Detail";
        this.currentData.pageStatus = "Detail";

        // 修复索引计算问题
        let currentIdx = parseInt(tab.name.replace("audited_tab", ""));
        if (currentIdx > 0 && currentIdx <= this.sortedAuditedList.length) {
          // 使用sortedAuditedList来获取正确的版本数据
          let currentData = this.sortedAuditedList[currentIdx - 1];
          if (currentData) {
            this.currentData.verifiedTime = currentData.verifiedTime;

            // 修复：更新版本信息为当前选中的版本
            this.updateVersionInfoFromAuditedData(currentData);

            // console.info(`Version Tab ${currentIdx} selected, pageStatus set to Detail, revNumber: ${currentData.revNumber}`);
          }
        }
      } else {
        // 其他情况，默认设置为Detail状态
        this.pageStatus = "Detail";
        this.currentData.pageStatus = "Detail";
        console.info("Unknown tab type, pageStatus set to Detail");
      }

      // 同步状态到localStorage
      localStorage.setItem("currentTabName", tab.name);
      localStorage.setItem("verifiedTime", this.currentData.verifiedTime);

      // console.info("Final pageStatus:", this.pageStatus, "tabName:", tab.name);

      // 通过EventBus通知所有组件状态变化
      this.$EventBus.$emit("pageStatusChange", this.pageStatus);

      // 强制重新渲染ZDComponentsVue组件，确保编辑状态正确应用
      if (tab.name === "tab1") {
        this.detailDataKey += 1;
      }

      // 延迟执行，确保状态更新完成后再触发组件重新初始化
      this.$nextTick(() => {
        // 通知ZDComponents组件重新初始化编辑状态
        this.$EventBus.$emit("tabChanged", {
          tabName: tab.name,
          pageStatus: this.pageStatus,
        });
      });
    },
    // 产品类型切换
    productTypeChange(type) {
      this.loadTemplateData(type);
      this.setupProductDescription("");
    },
    // 加载详情数据
    loadData() {
      // 防止重复调用
      if (this.isLoading) {
        console.warn('loadData already in progress, skipping...');
        return;
      }
      
      this.isLoading = true;
      this.loading = true;
      let type = this.$route.query.type;
      let id = this.$route.query.id;
      const isCopy = this.$route.query.isCopy;
      console.info("type==:",type)

      // 判断是否有用户信息，没有则需要登录
      

      apiServer.getDataByType(type, "getDetail", { id }, (data) => {
        console.info("load data--")
        
        // 重置加载状态
        this.isLoading = false;
        
        // 检查数据有效性
        if (!data) {
          console.error('No data received from API');
          this.loading = false;
          return;
        }
        
        if (!data.jsonValue) {
          console.error('No jsonValue in response:', data);
          this.loading = false;
          return;
        }
        
        let tmpData;
        try {
          tmpData = JSON.parse(data.jsonValue);
        } catch (error) {
          console.error('Failed to parse JSON:', error, 'Raw data:', data.jsonValue);
          this.loading = false;
          return;
        }
        // 统一数据管理，去除localStorage
        this.currentData.itemCode = data.itemCode;
        this.itemCode = data.itemCode;
        this.currentData.productType = data.productType;
        this.currentData.verified = data.verified;
        // console.info("tmpData.other_notes.shelflife_number22:",tmpData.other_notes.shelflife_number)

        if (tmpData.other_notes) {
          this.currentData.shelflifeNumber =
            tmpData.other_notes.shelflife_number;
          this.currentData.is_show_note = tmpData.other_notes.is_show_note;
          this.notesConfig.additionalNotes.note1 = tmpData.other_notes.note1;
          this.notesConfig.additionalNotes.note2 = tmpData.other_notes.note2;
          this.notesConfig.additionalNotes.note3 = tmpData.other_notes.note3;
          this.notesConfig.additionalNotes.is_show_note =
            tmpData.other_notes.is_show_note;
          this.notesConfig.additionalNotes.cnNote1 =
            tmpData.other_notes.is_show_note;
          if (tmpData.other_notes.notes) {
            this.currentData.notes = tmpData.other_notes.notes;
          }
        }
        if (tmpData.notes) {
          this.currentData.is_show_note = tmpData.notes.is_show_note;
          this.notesConfig.additionalNotes.note1 = tmpData.notes.note1;
          this.notesConfig.additionalNotes.note2 = tmpData.notes.note2;
          this.notesConfig.additionalNotes.note3 = tmpData.notes.note3;
          this.notesConfig.additionalNotes.is_show_note =
            tmpData.notes.is_show_note;
          this.notesConfig.additionalNotes.cnNote1 = tmpData.notes.is_show_note;
        }

        this.currentData.productDescription = data.productDescription;
        // console.info("tmpData.notes.:",tmpData.notes)
        // console.info("this.notesConfig.additionalNotes:",this.notesConfig.additionalNotes)
        if (type == "coa") {
          this.currentData.productType = tmpData.base_info.product_type;
          this.currentData.createTime = data.createTime;
          this.currentData.updateTime = data.updateTime;

          this.currentData.verifiedTime = data.verifiedTime;

          // 保存这些字段到currentData以便后续使用
          this.currentData.qty = data.qty;
          this.currentData.shipmentDate = data.shipmentDate;
          this.currentData.shippingMethod = data.shippingMethod;
          this.currentData.tyNumber = data.tyNumber;
          this.currentData.chinaLot = data.chinaLot || "";

          if (data.verifiedTime) {
            this.currentData.verifiedTime = data.verifiedTime;
          } else if (data.updateTime) {
            this.currentData.verifiedTime = data.updateTime;
          }

          //根据 item_code 加载 spec数据
          this.loadCoaDataBySpecItemCode(data.itemCode);
        }
        this.setupVersionInfo(data);

        // 保存默认数据
        this.defaultLoadData = tmpData;

        // 初始化notes数据
        if (tmpData.notes) {
          this.notesData = tmpData.notes;
          // 同步到notesConfig
          if (tmpData.notes.custom && Array.isArray(tmpData.notes.custom)) {
            this.notesConfig.customNotes = tmpData.notes.custom;
          }
          if (tmpData.notes.note1 !== undefined) {
            this.notesConfig.additionalNotes.note1 = tmpData.notes.note1;
          }
          if (tmpData.notes.note2 !== undefined) {
            this.notesConfig.additionalNotes.note2 = tmpData.notes.note2;
          }
          if (tmpData.notes.note3 !== undefined) {
            this.notesConfig.additionalNotes.note3 = tmpData.notes.note3;
          }
          if (tmpData.notes.is_show_note !== undefined) {
            this.notesConfig.additionalNotes.is_show_note =
              tmpData.notes.is_show_note;
          }
        }

        let productType = this.getCoaType(data.productType);
        this.productType = productType;

        ////console.info("productType==:",productType)
        if (!tmpData.base_info.product_type) {
          if (this.currentData.language == "en") {
            tmpData.base_info.product_type = "Powder";
          } else {
            tmpData.base_info.product_type = "TY-EHXTO";
          }
        }
        let coaType = productType + "-" + tmpData.base_info.product_type;
        // //console.info("coaType==:",coaType)
        let templateType = productType;
        if (type == "coa") {
          templateType = coaType;
        }
        const template = TemplateData.config.getDataByType(templateType);

        let templateVal = TemplateData.config.valueToTemplate(
          template,
          tmpData
        );

        if (type == "coa") {
          let specType = tmpData.base_info;
          if (typeof tmpData.base_info == "undefined") {
            specType = "CSFMU-B";
          } else {
            specType = tmpData.base_info.product_type;
          }
          console.info("specType:", specType);

          // 同步制造日期到currentData（copy 时不绑定，保持为空）
          if (
            tmpData.base_info &&
            tmpData.base_info.manufacuture_date &&
            !(isCopy === true || isCopy === "true")
          ) {
            this.currentData.manufacutureDate =
              tmpData.base_info.manufacuture_date;
          }

          // 同步shelflife_number到localStorage
          console.info("tmpData.other_notes.shelflife_number:")
          if (tmpData.other_notes && tmpData.other_notes.shelflife_number) {
            this.shelflifeNumber = parseInt(
              tmpData.other_notes.shelflife_number
            );
          }else if(data.shelflifeNumber){
            this.shelflifeNumber = parseInt(data.shelflifeNumber);
          }

          // 获取 spec 模板
          let specTemplate = TemplateData.config.getDataByType(coaType);
          // 为 specTemplate 添加空 result 属性
          let specTemplateAddResultAttr =
            TemplateData.config.transformJsonData(specTemplate);

          // 赋值处理
          let specTemplateVal = TemplateData.config.valueToTemplate(
            specTemplateAddResultAttr,
            tmpData
          );

          templateVal.microbiological_tests =
            specTemplateVal.microbiological_tests;
          templateVal.analysis = specTemplateVal.analysis;

          ////console.info('tmpData.notes.custom:',tmpData.notes.custom)
          templateVal.other_notes.notes.value = tmpData.notes.custom || [];
          ////console.info("specTemplateVal:", specTemplateVal);
        }

        ////console.info("templateVal>>>:", templateVal);

        // revision 数据
        ////console.info('isCopy==:',isCopy)
        if (isCopy == true || isCopy == "true") {
          ////console.info('aaaaaa==:',isCopy)
          templateVal.rev.revision.value = [];
          // copy 时不绑定 Manufacture Date 和 Expiration Date
          if (templateVal.base_info && templateVal.base_info.manufacuture_date) {
            templateVal.base_info.manufacuture_date.value = "";
          }
          if (templateVal.base_info && templateVal.base_info.expiration_date) {
            templateVal.base_info.expiration_date.value = "";
          }
        } else {
          // 兼容两种数据结构：rev.revision 与 revision
          if (tmpData && tmpData.rev && Array.isArray(tmpData.rev.revision)) {
            templateVal.rev.revision.value = tmpData.rev.revision;
          } else if (tmpData && Array.isArray(tmpData.revision)) {
            templateVal.rev.revision.value = tmpData.revision;
          } else {
            templateVal.rev.revision.value = [];
          }
        }

        // coa 权限设置
        this.coaAuthSetup(templateVal);

        // 测试
        // templateVal.base_info.custom_field.value = [
        //   {
        //     fields: "Draco Item Code",
        //     value: "CSFMU-TY-024",
        //     specification: "",
        //     test_method: "",
        //     result: "",
        //   },
        // ];
        // console.info(
        //   "templateVal.base_info.custom_field:",
        //   templateVal.base_info.custom_field
        // );
        // console.info("templateVal00:",templateVal)
        this.detailData = templateVal;
        
        // 修复：在 Detail 模式下也需要同步更新组件状态
        this.$nextTick(() => {
          this.updateCustomFieldComponentState('base_info', 'custom_field');
        });
        
        this.loading = false;
      }).catch(err => {
        this.isLoading = false;
        this.loading = false;
        console.error('API call failed:', err);
      });
    },
    coaProductTypeMapping(type) {
      let language = this.currentData.language; // 使用统一数据管理
      if (language == "en") {
        if (type == "SHXTO" || type == "EHXTO") {
          return type;
        } else if (
          type == "Liquid EXT-SH" ||
          type == "Liquid EXT-S" ||
          type == "Liquid EXT-B" ||
          type == "SDNP-L"
        ) {
          return "Liquid";
        } else {
          return "Powder";
        }
      } else {
        return type;
      }
    },
    coaAuthSetup(templateVal) {
      let type = this.$route.query.type;
      let userInfo = JSON.parse(localStorage.getItem("specUserInfo"));
      // 如果产品类型为 coa,并且用户角色为上海用户，则 base_info 的信息都设置为禁用
      if (!userInfo || !userInfo.roleId) {
            this.$confirm(
              this.$t("confirm.userinfo_error") || "用户信息获取失败，请重新登录",
              this.$t("confirm.tips"),
              {
                confirmButtonText: this.$t("confirm.ok"),
                cancelButtonText: this.$t("confirm.cancel"),
                type: "warning",
              }
            ).then(() => {
              // 使用 Vue 的方式跳转到登录页
              this.$router.push({ path: '/login' });
            });
            return;
        }
      if (userInfo.roleId == 3 && type == "coa") {
        Object.keys(templateVal.base_info).forEach((key) => {
          if ("disabled" in templateVal.base_info[key]) {
            templateVal.base_info[key].disabled = true;
          }
        });
        Object.keys(templateVal.general_specification).forEach((key) => {
          if ("disabled" in templateVal.general_specification[key]) {
            templateVal.general_specification[key].disabled = true;
          }
        });
      }
    },
    // 加载版本数据
    loadAuditVersionData() {
      this.loading = true;
      let type = this.$route.query.type;
      if (type == "coa") {
        // coa 没有版本数据
        return;
      }
      let id = this.$route.query.id;
      apiServer.getDataByType(type, "auditedList", { id }, (data) => {
        // console.info("auditedList:", data);
        this.$set(this, "auditedList", data || []);

        // 修复：确保初始状态正确设置
        if (data && data.length > 0) {
          // 如果有版本数据，设置第一页Version Tab为选中状态
          this.tabModel = "audited_tab1";

          // 重要：设置初始页面状态为Detail（不可编辑）
          this.pageStatus = "Detail";
          this.currentData.pageStatus = "Detail";

          // 同步到localStorage
          localStorage.setItem("currentTabName", this.tabModel);

          // 设置第一页的verifiedTime - 使用排序后的第一个版本
          if (this.sortedAuditedList.length > 0) {
            const firstVersion = this.sortedAuditedList[0];
            this.currentData.verifiedTime = firstVersion.verifiedTime;
            localStorage.setItem("verifiedTime", this.currentData.verifiedTime);

            // 修复：初始化时设置第一页的版本信息
            this.updateVersionInfoFromAuditedData(firstVersion);

            // console.info(`Initial Version Tab state set - pageStatus: ${this.pageStatus}, tabModel: ${this.tabModel}, revNumber: ${firstVersion.revNumber}`);
          }

          // console.info("Initial Version Tab state set - pageStatus:", this.pageStatus, "tabModel:", this.tabModel);

          // 通知组件状态变化
          this.$nextTick(() => {
            this.$EventBus.$emit("pageStatusChange", this.pageStatus);
            this.$EventBus.$emit("tabChanged", {
              tabName: this.tabModel,
              pageStatus: this.pageStatus,
            });
          });
        } else {
          // 如果没有版本数据，将页面状态设置为Edit，并选择Detail Manager标签页
          this.pageStatus = "Edit";
          this.currentData.pageStatus = "Edit";
          this.tabModel = "tab1";
          localStorage.setItem("currentTabName", this.tabModel);
          this.$nextTick(() => {
            this.$EventBus.$emit("pageStatusChange", this.pageStatus);
            this.$EventBus.$emit("tabChanged", {
              tabName: this.tabModel,
              pageStatus: this.pageStatus,
            });
          });
        }

        this.loading = false;
      });
    },
    loadSpecDataByItemCode(callback) {
      // 修复：在导入新数据之前捕获当前自定义字段状态
      this._captureCurrentCustomFieldDataState();

      
      let itemCode = this.currentData.itemCode; // 使用统一数据管理
      // console.info("[DEBUG] loadSpecDataByItemCode called with itemCode:", itemCode)
      // console.info("[DEBUG] Current language:", localStorage.getItem('language'))

      if (!itemCode) {
        // console.error("[ERROR] itemCode is empty or undefined")
        this.$message({
          message: "Item Code is required for import",
          type: "error",
        });
        callback(null);
        return;
      }

      // console.info("[DEBUG] Making API call to auditedLatestInfo")
      apiServer.getDataByType(
        "spec",
        "auditedLatestInfo",
        { itemCode },
        (data) => {
          // console.info("[DEBUG] API response received:", data)
          this.currentData.shelflifeNumber = data.shelflifeNumber;
          // console.info("[DEBUG] shelflifeNumber:", data.shelflifeNumber)
          if (data.success == true && data.data == null) {
            this.$message({
              message: this.$t("confirm.import_spec_fail"),
              type: "error",
            });
            callback(data);
            return;
          }

          // 检查jsonValue是否存在且有效
          if (!data.jsonValue) {
            this.$message({
              message: this.$t("confirm.import_spec_fail") + " - No JSON data",
              type: "error",
            });
            callback(data);
            return;
          }

          // 修复：在导入新数据之前清空 currentCustomFieldData
          // TODO：存储一下旧数据
          this.oldtCustomFieldData = this.currentCustomFieldData;
          console.info(
            "this.currentCustomFieldData.analysis:",
            this.currentCustomFieldData.analysis
          );
          this.currentCustomFieldData = {
            analysis: [],
            microbiological_tests: [],
            fatty_acid: [],
          };

          

          let tmpData;
          try {
            tmpData = JSON.parse(data.jsonValue);
          } catch (error) {
            console.error(
              "JSON parse error:",
              error,
              "jsonValue:",
              data.jsonValue
            );
            this.$message({
              message:
                this.$t("confirm.import_spec_fail") + " - Invalid JSON data",
              type: "error",
            });
            callback(data);
            return;
          }
          // data.jsonValue 中的 product_name 有可能为空
          if (!tmpData.base_info?.product_name) {
            tmpData.base_info.product_name = data.productName || "";
          }

          if (tmpData.notes) {
            this.notesData = tmpData.notes;
            // 同步到notesConfig
            if (tmpData.notes.custom && Array.isArray(tmpData.notes.custom)) {
              this.notesConfig.customNotes = tmpData.notes.custom;
            }
          }

          let productType = this.getCoaType(data.productType);
          // coa 类型映射
          let type = this.$route.query.type;
          let changeType = "";
          if (type == "coa") {
            productType = TemplateData.config.specTypeToCoaType(
              data.productType
            );
            changeType = productType
              .replaceAll("EN-Coa-", "")
              .replaceAll("CN-Coa-", "")
              .replaceAll("-", "_");
            console.info("changeType:",changeType)
            this.productTypeChange(changeType);
          }

          console.info("381-productType:",productType)
          const template = TemplateData.config.getDataByType(productType);
          let templateVal = TemplateData.config.valueToTemplate(
            template,
            tmpData
          );

          if (type == "coa") {
            //console.info("coa===============================")
            let ptype = this.coaProductTypeMapping(data.productType);
            templateVal.base_info.product_type.value = ptype;
            //console.info("shelflife_number:",tmpData.other_notes.shelflife_number)

            // 获得shelflife_number保质期月数
            let shelflifeNumber = tmpData.other_notes.shelflife_number;

            // 将shelflife_number保存到localStorage，以便ZDDate组件使用
            if (shelflifeNumber) {
              this.shelflifeNumber = parseInt(shelflifeNumber);
            }

            // 从currentData获取制造日期
            let manufacutureDate = this.currentData.manufacutureDate;
            //console.info("manufacutureDate33:",manufacutureDate)
            if (!manufacutureDate) {
              // 如果没有制造日期，尝试从外部数据获取
              manufacutureDate = this.getManufacutureDate();
            }

            if (manufacutureDate && manufacutureDate.length > 0) {
              let tmpDate = manufacutureDate;
              if (manufacutureDate.length === 7) {
                tmpDate += "-01";
              }
              let date = new Date(tmpDate);
              let shelflifeNumberVal = parseInt(shelflifeNumber);
              if (isNaN(shelflifeNumberVal)) {
                shelflifeNumberVal = 24;
              }
              ////console.info("设置：shelflifeNumber",shelflifeNumberVal)
              date.setMonth(date.getMonth() + shelflifeNumberVal);
              templateVal.base_info.manufacuture_date.value = manufacutureDate;
              templateVal.base_info.expiration_date.value = date
                .toISOString()
                .split("T")[0];
            }

            // 设置更新记录信息
            templateVal.update_rev = {
              revNumber: templateVal.rev.revision.value.length,
              updateDate:
                templateVal.rev.revision.value[
                  templateVal.rev.revision.value.length - 1
                ].revisionDate,
              verifyName:
                templateVal.rev.revision.value[
                  templateVal.rev.revision.value.length - 1
                ].verifyName,
            };

            // 处理notes数据
            if (tmpData.other_notes.notes.length > 0) {
              let notesArray = [];
              if (typeof tmpData.other_notes.notes === "string") {
                notesArray = tmpData.other_notes.notes
                  .split("@$")
                  .filter((item) => item.trim().length > 0);
              } else if (Array.isArray(tmpData.other_notes.notes)) {
                notesArray = tmpData.other_notes.notes;
              }
              templateVal.other_notes.notes = notesArray;
              this.notesConfig.customNotes = notesArray; // 同步到notesConfig
            } else {
              templateVal.other_notes.notes = [];
              this.notesConfig.customNotes = [];
            }

            // 根据不同的类型，加载microbiological_tests和analysis的字段值
            let specTemplateVal = TemplateData.config.valueToTemplate(
              template,
              tmpData
            );
            ////console.info("tmpData5555:",tmpData)
            ////console.info("specTemplateVal6666:",specTemplateVal)
            specTemplateVal =
              TemplateData.config.transformJsonData(specTemplateVal);
            templateVal.microbiological_tests =
              specTemplateVal.microbiological_tests;
            templateVal.analysis = specTemplateVal.analysis;
            templateVal.fatty_acid = specTemplateVal.fatty_acid;
            templateVal.spec_info = { product_type: "" };
            templateVal.spec_info.product_type = tmpData.base_info.product_type;
          }

          this.updateValueBySpecData(templateVal, tmpData);
          
          // 中文 coa result 值关联处理 - 在 updateValueBySpecData 之后调用，确保 this.detailData 已更新
          if(this.currentData.language == "cn"){
            this.$nextTick(() => {
              this.setupZhCoaResultDefaultValue(templateVal);
            });
          }
          
          if (callback) {
            callback(data);
          }
        }
      );
    },
    setupZhCoaResultDefaultValue(templateVal){
      Object.keys(zhCoaResultDefaultValue).forEach((key) => {
        const arrValue = zhCoaResultDefaultValue[key];
        console.info("key:",key, "arrValue:",arrValue)
        // arrValue 是对象（如 {identification: "合格", ...}），遍历每个字段，如果值为"specification"则用 templateVal 里的值，否则用默认值
        if (typeof arrValue === "object" && arrValue !== null) {
          Object.keys(arrValue).forEach(field => {
            // 修复：确保 this.detailData[key] 和 this.detailData[key][field] 存在
            if (
              !this.detailData[key] || 
              !this.detailData[key][field] ||
              !this.detailData[key][field].value
            ) {
              console.warn(`Field ${field} in ${key} does not exist in detailData`);
              return;
            }
            
            // 修复：确保 templateVal[key] 和 templateVal[key][field] 存在
            if (
              !templateVal[key] || 
              !templateVal[key][field] ||
              !templateVal[key][field].value
            ) {
              console.warn(`Field ${field} in ${key} does not exist in templateVal`);
              return;
            }
            
            if (
              arrValue[field] === "specification" &&
              templateVal[key][field].value &&
              templateVal[key][field].value.specification !== undefined &&
              templateVal[key][field].value.specification !== null &&
              String(templateVal[key][field].value.specification).trim().length > 0
            ) {
              // 使用 templateVal 中的 specification 值
              console.info("field,result:",field, templateVal[key][field].value.specification)
              this.$set(this.detailData[key][field].value, 'result', templateVal[key][field].value.specification);
            } else if (arrValue[field] !== "specification") {
              // 使用默认值
              this.$set(this.detailData[key][field].value, 'result', arrValue[field]);
            }
          });
        }
      });
    },
    setupVersionInfo(data) {
      const {
        createName = "",
        createTime = "",
        updateName = "",
        updateTime = "",
        revNumber = "",
        verifiedName = "",
        verifiedTime = "",
      } = data;

      // 修复：确保所有版本信息字段都被正确设置
      if (createName != null) {
        this.versionInfo.createName = createName;
      }
      if (createTime != null) {
        this.versionInfo.createTime = createTime?.substring(0, 10);
      }
      if (updateName != null) {
        this.versionInfo.updateName = updateName;
      }
      if (updateTime != null) {
        this.versionInfo.updateTime = updateTime?.substring(0, 10);
      }
      if (revNumber != null) {
        this.versionInfo.revNumber = revNumber;
      }
      if (verifiedName != null) {
        this.versionInfo.verifiedName = verifiedName;
      }
      if (verifiedTime != null) {
        this.versionInfo.verifiedTime = verifiedTime?.substring(0, 10);
      }

      // console.info("Version info setup completed:", this.versionInfo);
    },
    // 新增方法：从Vuex状态中保存当前的Custom Field数据
    _captureCurrentCustomFieldDataState() {
      this.currentCustomFieldData = {
        analysis: [],
        microbiological_tests: [],
        fatty_acid: [],
      };

      try {
        if (
          this.$store &&
          this.$store.state.zdInput &&
          this.$store.state.zdInput.components
        ) {
          const allStates = this.$store.state.zdInput.components;
          // 找出所有包含custom_field的zdId并保存数据
          Object.keys(allStates).forEach((zdId) => {
            if (
              zdId.includes("custom_field") &&
              allStates[zdId].value &&
              allStates[zdId].type === "three_custom_input"
            ) {
              const attr = allStates[zdId].attr;
              if (attr === "an_custom_field") {
                if (Array.isArray(allStates[zdId].value)) {
                  this.currentCustomFieldData.analysis = allStates[zdId].value;
                }
              } else if (attr === "mt_custom_field") {
                if (Array.isArray(allStates[zdId].value)) {
                  this.currentCustomFieldData.microbiological_tests =
                    allStates[zdId].value;
                }
              } else if (attr === "fa_custom_field") {
                if (Array.isArray(allStates[zdId].value)) {
                  this.currentCustomFieldData.fatty_acid =
                    allStates[zdId].value;
                }
              }
            }
          });
          console.info(
            "Captured current custom field data state:",
            this.currentCustomFieldData
          );
        }
      } catch (error) {
        console.warn(
          "Failed to capture current custom field data state from Vuex:",
          error
        );
      }
    },
    // 新增方法：从Vuex中获取指定模块的Custom Field数据
    getCustomFieldDataFromVuex(moduleName) {
      // 根据模块名获取对应的attr值
      const attrMap = {
        analysis: "an_custom_field",
        microbiological_tests: "mt_custom_field",
        fatty_acid: "fa_custom_field",
      };

      const targetAttr = attrMap[moduleName];
      if (!targetAttr) {
        console.warn(`Unknown module name: ${moduleName}`);
        return [];
      }

      // 在所有Vuex状态中查找匹配的custom field
      try {
        if (
          this.$store &&
          this.$store.state.zdInput &&
          this.$store.state.zdInput.components
        ) {
          const allStates = this.$store.state.zdInput.components;

          for (const zdId of Object.keys(allStates)) {
            const state = allStates[zdId];
            if (
              state.type === "three_custom_input" &&
              state.attr === targetAttr &&
              state.value &&
              Array.isArray(state.value)
            ) {
              console.info(
                `Found ${moduleName} custom field data from zdId ${zdId}:`,
                state.value
              );
              return state.value;
            }
          }
        }
      } catch (error) {
        console.warn(
          `Failed to get ${moduleName} custom field from Vuex:`,
          error
        );
      }

      console.warn(
        `No custom field data found for ${moduleName} (attr: ${targetAttr})`
      );
      return [];
    },
    updateValueBySpecData(templateVal, tmpData) {
      // ////console.info("start defaultLoadData:", this.defaultLoadData.base_info);
      console.info("Import For Spec - tmpData from API:", tmpData);
      console.info(
        "Current preserved custom field data:",
        this.currentCustomFieldData
      );

      const baseInfoKeys = [
        "product_type",
        "item_code",
        "print_title",
        "product_name",
        "customer_product_name",
        "version_number",
        "manufacuture_date",
        "expiration_date",
        "item_code",
        "custom_field",
      ];

      // general_specification
      if (templateVal.general_specification) {
        for (const key in templateVal.general_specification) {
          if (
            this.detailData.general_specification[key] &&
            templateVal.general_specification[key] !== undefined
          ) {
            if (
              templateVal.general_specification[key].value &&
              templateVal.general_specification[key].value.length > 0
            ) {
              this.detailData.general_specification[key].value =
                templateVal.general_specification[key].value;
            }
          }
        }
      }
      //console.info('this.detailData["analysis"]',this.detailData["analysis"])
      ////console.info('templateVal.analysis',templateVal.analysis)
      Object.keys(templateVal.analysis).forEach((key) => {
        if (key == "custom_field") {
          // 确保this.detailData["analysis"][key]有正确的结构
          if (
            !this.detailData["analysis"][key] ||
            !this.detailData["analysis"][key].value
          ) {
            this.detailData["analysis"][key] = {
              type: "three_custom_input",
              label: "custom_field",
              value: [],
              disabled: false,
              display: true,
              attr: "an_custom_field",
            };
          }

          // 处理 custom_field 的数组数据
          // const currentCustomFields = this.currentCustomFieldData.analysis || [];
          console.info("adsfafds:", this.oldtCustomFieldData);

          if (
            templateVal.analysis[key].value &&
            Array.isArray(templateVal.analysis[key].value) &&
            templateVal.analysis[key].value.length > 0
          ) {
            // 从Spec导入的数据有内容，需要合并保留result值
            this.detailData["analysis"][key].value = templateVal.analysis[
              key
            ].value.map((obj, index) => {
              console.info("fields", obj["fields"]);
              console.info(
                "index result",
                this.oldtCustomFieldData.analysis[index]
              );
              let tmpResult = "";
              // 安全检查：确保 oldtCustomFieldData.analysis 存在且 index 在范围内
              if (
                this.oldtCustomFieldData.analysis &&
                Array.isArray(this.oldtCustomFieldData.analysis) &&
                index < this.oldtCustomFieldData.analysis.length &&
                this.oldtCustomFieldData.analysis[index] &&
                this.oldtCustomFieldData.analysis[index].result !== undefined
              ) {
                tmpResult = this.oldtCustomFieldData.analysis[index].result;
              }
              return {
                fields: obj["fields"] || "",
                value: obj["value"] || "",
                specification: obj["specification"] || "",
                test_method: obj["test_method"] || "",
                // 保留用户已填写的result值，如果没有则使用空字符串
                result: tmpResult,
              };
            });
            console.info(
              "analysis custom_field updated with Spec data, preserving result values:",
              this.detailData["analysis"][key].value
            );
          } else {
            // 从Spec导入的数据为空数组，不再保留用户已填写的数据，直接清空
            this.detailData["analysis"][key].value = [];
            console.info(
              "analysis custom_field cleared (Spec data is empty):",
              this.detailData["analysis"][key].value
            );
          }
          
          // 修复：同步更新 Vuex store 中对应组件的状态
          this.$nextTick(() => {
            this.updateCustomFieldComponentState('analysis', key);
          });
        } else {
          let specification = templateVal.analysis[key].value.specification;
          let test_method = templateVal.analysis[key].value.test_method;
          this.detailData["analysis"][key].value.specification = specification;
          this.detailData["analysis"][key].value.test_method = test_method;
        }
      });
      Object.keys(templateVal.microbiological_tests).forEach((key) => {
        if (key == "custom_field") {
          // 确保this.detailData["microbiological_tests"][key]有正确的结构
          if (
            !this.detailData["microbiological_tests"][key] ||
            !this.detailData["microbiological_tests"][key].value
          ) {
            this.detailData["microbiological_tests"][key] = {
              type: "three_custom_input",
              label: "custom_field",
              value: [],
              disabled: false,
              display: true,
              attr: "mt_custom_field",
            };
          }

          // 处理 custom_field 的数组数据
          // const currentCustomFields = this.currentCustomFieldData.microbiological_tests || [];

          if (
            templateVal.microbiological_tests[key].value &&
            Array.isArray(templateVal.microbiological_tests[key].value) &&
            templateVal.microbiological_tests[key].value.length > 0
          ) {
            // 从Spec导入的数据有内容，需要合并保留result值
            this.detailData["microbiological_tests"][key].value =
              templateVal.microbiological_tests[key].value.map(
                (obj, index) => {
                  // 安全检查：确保 oldtCustomFieldData.microbiological_tests 存在且 index 在范围内
                  let resultValue = "";
                  if (
                    this.oldtCustomFieldData.microbiological_tests &&
                    Array.isArray(this.oldtCustomFieldData.microbiological_tests) &&
                    index < this.oldtCustomFieldData.microbiological_tests.length &&
                    this.oldtCustomFieldData.microbiological_tests[index] &&
                    this.oldtCustomFieldData.microbiological_tests[index].result !== undefined
                  ) {
                    resultValue = this.oldtCustomFieldData.microbiological_tests[index].result;
                  }
                  
                  return {
                    fields: obj["fields"] || "",
                    value: obj["value"] || "",
                    specification: obj["specification"] || "",
                    test_method: obj["test_method"] || "",
                    // 保留用户已填写的result值，如果没有则使用空字符串
                    result: resultValue,
                  };
                }
              );
            console.info(
              "microbiological_tests custom_field updated with Spec data, preserving result values:",
              this.detailData["microbiological_tests"][key].value
            );
          } else {
            // 从Spec导入的数据为空数组，不再保留用户已填写的数据，直接清空
            this.detailData["microbiological_tests"][key].value = [];
            console.info(
              "microbiological_tests custom_field cleared (Spec data is empty):",
              this.detailData["microbiological_tests"][key].value
            );
          }
          
          // 修复：同步更新 Vuex store 中对应组件的状态
          this.$nextTick(() => {
            this.updateCustomFieldComponentState('microbiological_tests', key);
          });
        } else {
          let specification =
            templateVal.microbiological_tests[key].value.specification;
          let test_method =
            templateVal.microbiological_tests[key].value.test_method;
          // let result = templateVal.microbiological_tests[key].value.result;
          this.detailData["microbiological_tests"][key].value.specification =
            specification;
          this.detailData["microbiological_tests"][key].value.test_method =
            test_method;
          // this.detailData["microbiological_tests"][key].value.result = result;
          // console.info("result:",result)
          // this.detailData["microbiological_tests"][key].value.result = this.oldtCustomFieldData.microbiological_tests[0].result;
          // console.info("this.oldtCustomFieldData.microbiological_tests[index].result:",this.oldtCustomFieldData.microbiological_tests[0].result)
        }
      });

      if (templateVal.fatty_acid) {
        Object.keys(templateVal.fatty_acid).forEach((key) => {
          if (key == "custom_field") {
            // 确保this.detailData["fatty_acid"][key]有正确的结构
            if (
              !this.detailData["fatty_acid"][key] ||
              !this.detailData["fatty_acid"][key].value
            ) {
              this.detailData["fatty_acid"][key] = {
                type: "three_custom_input",
                label: "custom_field",
                value: [],
                disabled: false,
                display: true,
                attr: "fa_custom_field",
              };
            }

            // 处理 custom_field 的数组数据
            // const currentCustomFields = this.currentCustomFieldData.fatty_acid || [];

            if (
              templateVal.fatty_acid[key].value &&
              Array.isArray(templateVal.fatty_acid[key].value) &&
              templateVal.fatty_acid[key].value.length > 0
            ) {
              // 从Spec导入的数据有内容，需要合并保留result值
              this.detailData["fatty_acid"][key].value = templateVal.fatty_acid[
                key
              ].value.map((obj, index) => {
                // 安全检查：确保 oldtCustomFieldData.fatty_acid 存在且 index 在范围内
                let resultValue = "";
                if (
                  this.oldtCustomFieldData.fatty_acid &&
                  Array.isArray(this.oldtCustomFieldData.fatty_acid) &&
                  index < this.oldtCustomFieldData.fatty_acid.length &&
                  this.oldtCustomFieldData.fatty_acid[index] &&
                  this.oldtCustomFieldData.fatty_acid[index].result !== undefined
                ) {
                  resultValue = this.oldtCustomFieldData.fatty_acid[index].result;
                }
                
                return {
                  fields: obj["fields"] || "",
                  value: obj["value"] || "",
                  specification: obj["specification"] || "",
                  test_method: obj["test_method"] || "",
                  // 保留用户已填写的result值，如果没有则使用空字符串
                  result: resultValue,
                };
              });
              console.info(
                "fatty_acid custom_field updated with Spec data, preserving result values:",
                this.detailData["fatty_acid"][key].value
              );
            } else {
              // 从Spec导入的数据为空数组，不再保留用户已填写的数据，直接清空
              this.detailData["fatty_acid"][key].value = [];
              console.info(
                "fatty_acid custom_field cleared (Spec data is empty):",
                this.detailData["fatty_acid"][key].value
              );
            }
            
            // 修复：同步更新 Vuex store 中对应组件的状态
            this.$nextTick(() => {
              this.updateCustomFieldComponentState('fatty_acid', key);
            });
          } else {
            let specification = templateVal.fatty_acid[key].value.specification;
            let test_method = templateVal.fatty_acid[key].value.test_method;
            this.detailData["fatty_acid"][key].value.specification =
              specification;
            this.detailData["fatty_acid"][key].value.test_method = test_method;
            // 安全检查：确保 oldtCustomFieldData.fatty_acid 存在且有数据
            if (
              this.oldtCustomFieldData.fatty_acid &&
              Array.isArray(this.oldtCustomFieldData.fatty_acid) &&
              this.oldtCustomFieldData.fatty_acid.length > 0 &&
              this.oldtCustomFieldData.fatty_acid[0] &&
              typeof this.oldtCustomFieldData.fatty_acid[0].result !== "undefined"
            ) {
              this.detailData["fatty_acid"][key].value.result =
                this.oldtCustomFieldData.fatty_acid[0].result;
              console.info(
                "this.oldtCustomFieldData.fatty_acid[index].result",
                this.oldtCustomFieldData.fatty_acid[0].result
              );
            }
          }
        });
      }
      baseInfoKeys.forEach((key) => {
        ////console.info('key:',key)
        ////console.info('templateVal.base_info[key]:',templateVal.base_info[key])
        if (key == "custom_field") {
          console.info("custom_field:", templateVal.base_info[key].value);
          this.detailData.base_info[key].value = templateVal.base_info[key].value;
          // this.detailData.base_info.custom_field.value = [
          //   {
          //     fields: "Draco Item Code11111",
          //     value: "CSFMU-TY-02411111",
          //     specification: "",
          //     test_method: "",
          //     result: "",
          //   },
          // ];
          
          // 修复：同步更新 Vuex store 中对应组件的状态
          this.$nextTick(() => {
            this.updateCustomFieldComponentState('base_info', key);
          });
        } else if (
          templateVal.base_info[key] &&
          templateVal.base_info[key].value !== undefined
        ) {
          this.detailData.base_info[key].value =
            templateVal.base_info[key].value;
        }
      });

      // TODO:通过 event bus 更新 notes
      EventBus.$emit("eventupdateNotes", templateVal.other_notes.notes);
      // ////console.info("other_notes:", this.detailData.other_notes);
      // this.detailData = templateVal;
    },
    // 绑定 module
    getAuditedData(item) {
      let tmpData = JSON.parse(item.jsonValue);

      const mergedData = TemplateData.config.mergeTemplateWithSavedData(
        item.productType,
        tmpData,
        true
      );
      //console.info("tmpData:", tmpData);
      // ////console.info("getAuditedData:", mergedData);
      // ////console.info("mergedData.rev.revision-start:", mergedData.rev.revision);
      // 兼容两种数据结构：rev.revision 与 revision
      if (tmpData && tmpData.rev && Array.isArray(tmpData.rev.revision)) {
        if (mergedData && mergedData.rev && mergedData.rev.revision) {
          mergedData.rev.revision.value = tmpData.rev.revision;
        }
      } else if (tmpData && Array.isArray(tmpData.revision)) {
        if (mergedData && mergedData.rev && mergedData.rev.revision) {
          mergedData.rev.revision.value = tmpData.revision;
        }
      }
      //console.info("mergedData:", mergedData);

      // ////console.info("mergedData.rev.revision-end:", mergedData.rev.revision);
      return mergedData;
    },
    getCoaType(productType) {
      let type = this.$route.query.type;
      if (type == "coa") {
        let lang = this.currentData.language.toUpperCase();
        if (lang == "zh" || lang == "cn") {
          lang = "CN";
        }
        productType = lang + "-Coa";
      }
      ////console.info("productType>>:", productType);
      return productType;
    },
    // 加载模板数据
    loadTemplateData(productType = "CSFMU-B") {
      let selectProductType = productType;
      this.productType = productType;
      let language = this.$route.query.language.toLocaleLowerCase();
      let type = this.$route.query.type;
      
      console.info('loadTemplateData 调试信息:');
      console.info('- 初始 productType:', productType);
      console.info('- language:', language);
      console.info('- type:', type);
      console.info('- pageStatus:', this.pageStatus);
      
      // 判断是否是 coa 类型
      if (type == "coa") {
        if (language == "cn" || language == "zh") {
          productType = "CN-Coa";
          if (selectProductType == "CSFMU-B") {
            selectProductType = "TY-EHXTO";
          }
        } else {
          productType = "EN-Coa";
          if (selectProductType == "CSFMU-B") {
            selectProductType = "Powder";
          }
        }
      } else {
        //判断是否是中文 spec
        console.info('进入 spec 分支，检查转换条件:');
        console.info('- language == "cn":', language == "cn");
        console.info('- this.pageStatus == "Add":', this.pageStatus == "Add");
        console.info('- productType == "CSFMU-B":', productType == "CSFMU-B");
        
        if (
          language == "cn" &&
          this.pageStatus == "Add" &&
          productType == "CSFMU-B"
        ) {
          console.info('条件满足，将 productType 从 CSFMU-B 转换为 TY-P');
          productType = "TY-P";
        }
      }
      console.info('- 最终 productType:', productType);
      this.productType = productType;
      
      // 同步更新 currentData.productType
      this.currentData.productType = productType;
      console.info('- 同步后的 currentData.productType:', this.currentData.productType);

      // 切换模板
      ////console.info("selectProductType==:",productType+"-"+selectProductType)
      let templateType = productType;
      if (type == "coa") {
        templateType = productType + "-" + selectProductType;
        templateType = templateType.replaceAll("_", "-");
      }
      let templateData = TemplateData.config.getDataByType(templateType);
      // ////console.info("templateData:", templateData);
      let valueDetail = templateData;

      if (this.defaultLoadData.base_info) {
        this.defaultLoadData.base_info.product_type = productType;
      }
      if (
        this.defaultLoadData &&
        Object.keys(this.defaultLoadData).length > 0
      ) {
        // 加载内容到模板中
        valueDetail = TemplateData.config.valueToTemplate(
          templateData,
          this.defaultLoadData
        );
      } else {
        // 设置默认值
        valueDetail.base_info.product_type.value = productType;
        valueDetail = TemplateData.config.assignTipsValue(valueDetail);
      }

      if (type == "coa" && language == "cn") {
        valueDetail.base_info.product_type.value = selectProductType;
      } else if (type == "coa" && language == "en") {
        valueDetail.base_info.product_type.value = selectProductType;
      }

      // 同步制造日期到currentData（如果存在）
      if (
        valueDetail.base_info &&
        valueDetail.base_info.manufacuture_date &&
        valueDetail.base_info.manufacuture_date.value
      ) {
        this.currentData.manufacutureDate =
          valueDetail.base_info.manufacuture_date.value;
      }

      // 使用 Vue.set 以确保响应式
      this.$set(this, "detailData", valueDetail || {});
      this.detailDataKey += 1; // 强制重新渲染 ZDComponentsVue
    },
    setupProductDescription(value) {
      //  TY-EHXTO、TY-SHXTO 类别
      // console.info("setupProductDescription")
      let language = this.currentData.language.toLocaleLowerCase();
      let paramsType = this.$route.query.type;
      if (language == "cn" || language == "zh") {
        if (this.pageStatus == "Add" && paramsType == "spec") {
          console.info("this.pageStatus1111:", this.pageStatus);
          // 不区分类型，直接替换两个占位符
          let description =
            this.detailData.base_info.product_description.tips_value
              .replace("${general_specification.common_other_name}", value)
              .replace("${general_specification.botanical_name}", value);
          this.detailData.base_info.product_description.value = description;
        }
      }
    },

    // 新增：获取制造日期的方法
    getManufacutureDate() {
      // 从currentData获取
      if (this.currentData.manufacutureDate) {
        return this.currentData.manufacutureDate;
      }

      // 从detailData中获取制造日期
      if (
        this.detailData &&
        this.detailData.base_info &&
        this.detailData.base_info.manufacuture_date
      ) {
        return this.detailData.base_info.manufacuture_date.value;
      }

      return null;
    },

    // 新增：从审核版本数据更新版本信息
    updateVersionInfoFromAuditedData(auditedData) {
      if (auditedData) {
        // 更新版本信息为当前选中的审核版本
        this.versionInfo.revNumber = auditedData.revNumber || "";
        this.versionInfo.createName = auditedData.createName || "";
        this.versionInfo.createTime = auditedData.createTime
          ? auditedData.createTime.substring(0, 10)
          : "";
        this.versionInfo.updateName = auditedData.updateName || "";
        this.versionInfo.updateTime = auditedData.updateTime
          ? auditedData.updateTime.substring(0, 10)
          : "";
        this.versionInfo.verifiedName = auditedData.verifiedName || "";
        this.versionInfo.verifiedTime = auditedData.verifiedTime
          ? auditedData.verifiedTime.substring(0, 10)
          : "";

        // console.info("Version info updated from audited data:", this.versionInfo);
      }
    },

    // 新增：从详情数据恢复版本信息
    updateVersionInfoFromDetailData() {
      // 恢复为原始详情数据的版本信息
      if (
        this.defaultLoadData &&
        this.defaultLoadData.rev &&
        this.defaultLoadData.rev.revision
      ) {
        const revisionData = this.defaultLoadData.rev.revision;
        if (Array.isArray(revisionData) && revisionData.length > 0) {
          // 获取最新的版本信息
          const latestRevision = revisionData[revisionData.length - 1];
          this.versionInfo.revNumber =
            latestRevision.revisionNumber || this.versionInfo.revNumber || "";
        }
      }

      // 保持其他版本信息不变（从原始数据加载时的值）
      // console.info("Version info restored from detail data:", this.versionInfo);
    },
    // 新增：获取 shelflifeNumber 的方法
    getShelflifeNumber() {
      return this.shelflifeNumber;
    },
    // 登出处理
    handleLogout() {
      this.$confirm(
        this.$t('confirm.logout_confirm'),
        this.$t('confirm.tips'),
        {
          confirmButtonText: this.$t('confirm.confirm'),
          cancelButtonText: this.$t('confirm.cancel'),
          distinguishCancelAndClose: true,
          type: "warning",
        }
      )
        .then(() => {
          this.logout();
        })
        .catch(() => {
          // 用户取消，不做任何操作
        });
    },
    // 登出方法
    logout() {
      try {
        const token = localStorage.getItem("specToken");
        const userInfo = localStorage.getItem("specUserInfo");
        
        if (!token || !userInfo) {
          // 如果没有token或用户信息，直接跳转
          this.redirectToLogin();
          return;
        }

        const id = JSON.parse(userInfo).id;

        // 调用登出API
        this.$api
          .logout({ id, token })
          .then(() => {
            // 清除本地存储
            localStorage.removeItem("specToken");
            localStorage.removeItem("specUserInfo");
            
            // 显示成功消息
            this.$message({
              type: "success",
              message: this.$t('confirm.logout_success'),
            });
            
            // 跳转到登录页
            this.redirectToLogin();
          })
          .catch((err) => {
            console.error("Logout error:", err);
            // 即使API调用失败，也清除本地存储并跳转
            localStorage.removeItem("specToken");
            localStorage.removeItem("specUserInfo");
            this.redirectToLogin();
          });
      } catch (error) {
        console.error("Logout error:", error);
        // 发生错误时也清除本地存储并跳转
        localStorage.removeItem("specToken");
        localStorage.removeItem("specUserInfo");
        this.redirectToLogin();
      }
    },
    // 跳转到登录页
    redirectToLogin() {
      const language = this.currentData.language.toLowerCase();
      const isCn = language === "cn" || language === "zh";
      const loginPath = isCn ? "/cn-login" : "/login";
      this.$router.replace({ path: loginPath });
    },
  },
};
</script>

<style scoped>
.tabs-wrapper {
  position: relative;
}

.logout-btn {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  height: 40px;
  line-height: 40px;
  border-radius: 0;
  border-top: none;
  border-right: none;
  border-bottom: none;
  border-left: 1px solid #dcdfe6;
  padding: 0 15px;
}

/* 确保按钮与 tab 标签页样式一致 */
.tabs-wrapper ::v-deep .el-tabs__header {
  margin: 0;
}

.tabs-wrapper ::v-deep .el-tabs__item {
  height: 40px;
  line-height: 40px;
}
</style>

